import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { DrawerBody, DrawerModal } from '@doltech/ui/lib/figma/Mobile/Modal/DrawerModal';
import { TestTypeEnum } from '@doltech/utils/lib/constants';
import { Tabs } from 'antd';
import cl from 'classnames';
import * as React from 'react';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import {
  BodyWrapper,
  ButtonFooter,
  DivQuestionBox,
  OverallTitle,
  QuestionGroupList,
  QuestionList,
} from './OverallDrawerModal';

interface OverallDrawerModalProps {
  visible: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  goToQuestion?: (question: string, testSectionIndex: number, groupIndex: number) => void;
}

const noPaddingStyle = { padding: 0 };

const renderQuestionGroup = (group, index, qIndex, onGoToQuestion) => {
  return (
    <QuestionGroupList key={qIndex} className="question-group-list">
      <Typography.Text variant="medium/10-16" color="black60">
        {group.groupName}
      </Typography.Text>
      <QuestionList>
        {group.questions.map((question) => {
          const { bottomBarQuestionNoes } = question;
          return bottomBarQuestionNoes?.map(({ no, answered }) => {
            return (
              <DivQuestionBox
                key={no}
                className={cl({ active: answered })}
                onClick={() => onGoToQuestion(`question-no-${no}`, index, qIndex)}
              >
                {no}
              </DivQuestionBox>
            );
          });
        })}
      </QuestionList>
    </QuestionGroupList>
  );
};

export const ReadingOverallDrawerModal = ({
  goToQuestion,
  onSubmit,
  visible,
  onClose,
}: OverallDrawerModalProps) => {
  const store = useTestSubmissionStore();

  const isFullTest = store.testType === TestTypeEnum.FULL_TEST;

  return (
    <DrawerModal
      height="auto"
      maxHeight="64vh"
      bodyStyle={noPaddingStyle}
      visible={visible}
      onClose={onClose}
      footer={false}
      closable={false}
      title={
        <OverallTitle
          title="Overall"
          subTitle={isFullTest ? null : `Total: ${store.totalQuestions} questions`}
          onClose={onClose}
        />
      }
    >
      <DrawerBody footer style={{ marginTop: 0 }}>
        <BodyWrapper>
          {isFullTest && (
            <Tabs hideAdd className="passage-tabs" defaultActiveKey="0">
              {store.testSections.map((testSection, index) => (
                <Tabs.TabPane tab={`Passage ${index + 1}`} key={index} closable={false}>
                  <div>
                    {testSection.questionGroups.map((group, qIndex) =>
                      renderQuestionGroup(group, index, qIndex, goToQuestion)
                    )}
                  </div>
                </Tabs.TabPane>
              ))}
            </Tabs>
          )}
          {!isFullTest &&
            store.testSections.map((testSection, index) => (
              <div key={index}>
                {testSection.questionGroups.map((group, qIndex) =>
                  renderQuestionGroup(group, index, qIndex, goToQuestion)
                )}
              </div>
            ))}
        </BodyWrapper>
      </DrawerBody>
      <ButtonFooter>
        <Button.Primary onClick={onSubmit} style={{ height: 48 }}>
          Submit
        </Button.Primary>
      </ButtonFooter>
    </DrawerModal>
  );
};
